import React from "react";
import classes from "./Footer.scss";
import { Button } from "@toddle-edu/ds-web";

const Footer = props => {
  const {
    t,
    onClickCancel,
    onClickAdd,
    isAddButtonDisabled,
    selectedEvidenceCount,
    addButtonLabel,
    isCompactUINeeded,
    cancelButtonSize = "large",
    addButtonSize = "large",
  } = props;
  const labelContainerClass = isCompactUINeeded
    ? "text-label"
    : classes.evidenceCountCon;
  const cancelContainerClass = isCompactUINeeded
    ? classes.updatedCancelButton
    : classes.cancelButton;

  return (
    <div className={classes.container}>
      <div className={labelContainerClass}>
        {t("snp:selected_evidence_count", {
          count: selectedEvidenceCount,
        })}
      </div>
      <div className={classes.btnCon}>
        <div className={cancelContainerClass}>
          <Button
            variant="neutral"
            type="outlined"
            onClick={onClickCancel}
            size={cancelButtonSize}
            dsVersion="2.0"
          >
            {t(`common:cancel`)}
          </Button>
        </div>
        <Button
          variant={"progressive"}
          disabled={isAddButtonDisabled}
          onClick={onClickAdd}
          size={addButtonSize}
          dsVersion="2.0"
          shortcut={{ code: "Enter", shiftKey: true }}
        >
          {addButtonLabel ? addButtonLabel : t(`common:add`)}
        </Button>
      </div>
    </div>
  );
};

export default Footer;
